(function () {
  let currentClickHandler = null;

  function attachClickListener(element, sku) {
    if (currentClickHandler) {
      element.removeEventListener("click", currentClickHandler);
    }

    currentClickHandler = function (event) {
      if (ShoeSizeMe_loader) {
        ShoeSizeMe_loader.action(sku, event, element);
      }
    };
    element.addEventListener("click", currentClickHandler);
  }

  function updateShoeAIElement(variant, productData) {
    if (!variant || !variant.sku) return;

    const newSKU = variant.sku.substring(0, 13);
    const allElements = document.querySelectorAll(".ShoeSizeMe.ssm_pdp");
    
    if (allElements.length === 0) return;

    allElements.forEach(el => {
      el.classList.add("hidden");
    });

    // Show the matching element
    const matchingElement = Array.from(allElements).find(el => {
      return el.getAttribute("data-shoeid") === newSKU;
    });

    if (matchingElement) {
      matchingElement.classList.remove("hidden");
      
      if (ShoeSizeMe_loader?.rebuildAllButton) {
        ShoeSizeMe_loader.rebuildAllButton();
      }
    }
  }

  function processSizeValue(size) {
    if (size && size.includes("|")) {
      const parts = size.split(" ");
      return parts[parts.length - 1];
    }
    return size;
  }

  function getAvailableSizes(variant, productData) {
    if (!productData || !Array.isArray(productData)) return null;

    const sizeIndex = 2;
    const selectedColor = variant.option1;
    const selectedFit = variant.option2;

    const allSizes = new Set();
    productData.forEach((v) => {
      if (v.options && v.options[sizeIndex]) {
        const processedSize = processSizeValue(v.options[sizeIndex]);
        allSizes.add(processedSize);
      }
    });

    const availableSizes = new Set();
    productData.forEach((v) => {
      if (v.available && v.option1 === selectedColor && v.option2 === selectedFit && v.options && v.options[sizeIndex]) {
        const processedSize = processSizeValue(v.options[sizeIndex]);
        availableSizes.add(processedSize);
      }
    });

    const sizerun = Array.from(allSizes).join(",");
    const availability = Array.from(availableSizes).join(",");

    return {
      sizerun: sizerun,
      availability: availability,
    };
  }

  document.addEventListener("product:variant-change", (e) => {
    updateShoeAIElement(e.detail.variant, getProductData(e.detail.sectionId));
  });

  function getProductData(sectionId) {
    try {
      const el = document.querySelector(`variant-selects[data-section=${sectionId}]`);
      return el ? el.getVariantData() : null;
    } catch (e) {
      return null;
    }
  }
})();
